// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3EAb5","disabled":"FileBtn_disabled__2PEUh","warn":"FileBtn_warn__31WG8","fade":"FileBtn_fade__nQAT1"};